import {
	AppBar,
	Dialog,
	IconButton,
	Toolbar,
	WithStyles,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import grey from '@material-ui/core/colors/grey';
import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import ChevronRight from '@material-ui/icons/ChevronRight';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { UpwardTransition } from 'src/utils';
import { isMobile } from '../utils/MobileCheck';

import CloseIcon from '@material-ui/icons/Close';
import {
	ICareerClass,
	ICareerInfo,
	setCareerDetail,
	setCourseDetailDialog,
} from '../actions/search';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory from '../scenario/SearchScenarioFactory';
import Config from '../site.config.json';
import { Routes, Screens } from '../utils/Routes';
import CourseDetail from './CourseDetail';

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		button: {
			margin: '10px',
		},
		careerDialog: {
			width: '80%',
		},
		cellItemName: {
			backgroundColor: grey[300],
			minWidth: '160px',
			textAlign: 'right',
			width: '20%',
		},
		cellItemValue: {
			textAlign: 'left',
			width: '80%',
		},
		downloadButton: {
			cursor: 'pointer',
			marginLeft: 20,
			verticalAlign: 'middle',
		},
		flex: {
			flex: 1,
		},
		headerName: {
			backgroundColor: grey[300],
		},
		link: {
			color: 'rgb(0,136,204)',
			cursor: 'pointer',
			fontWeight: 'bold',
		},
		listItem: {
			backgroundColor: '#CDE3ED',
			borderRadius: '5px',
			marginBottom: '2px',
		},
		mobileCellItemName: {
			alignItems: 'center',
			backgroundColor: grey[300],
			display: 'flex',
			minHeight: '40px',
			minWidth: '10px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileCellItemValue: {
			alignItems: 'center',
			display: 'flex',
			minHeight: '40px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileFlex: {
			flex: 1,
			fontSize: '16px',
		},
		mobileTable: {
			minWidth: '100px',
		},
		paper: {
			overflowX: 'auto',
		},
		root: {
			flexGrow: 1,
			padding: 18,
		},
		scrollPaper: {
			alignItems: 'flex-start',
		},
		table: {
			minWidth: '700px',
		},
		tableClass: {
			minWidth: '1000px',
		},
		wrapDiv: {
			margin: '10px',
		},
	});

interface IRouteParams {
	career_id: string;
}

// tslint:disable-next-line: no-empty-interface
interface IRouteState {}

interface IState {
	careerInfoOpen: boolean;
	classInfoOpen: boolean;
	detailInfoOpen: boolean;
}

/**
 * 研修情報詳細
 */
class CareerDetail extends React.Component<IProps, IState> {
	protected elmForm: HTMLFormElement | null;

	protected elmDownloadWindowTitle: HTMLInputElement | null;

	protected elmDownloadFileType: HTMLInputElement | null;

	protected elmParameters: HTMLInputElement | null;

	protected materialDownloadForm: HTMLFormElement | null;

	protected fileIndexInput: HTMLInputElement | null;

	public constructor(props: IProps) {
		super(props);
		if (this.props.careerID) {
			this.props.fetchCareerDetail(this.props.careerID, this.props.token);
		}

		this.state = {
			careerInfoOpen: false,
			classInfoOpen: false,
			detailInfoOpen: false,
		};
		this.onClickPlace = this.onClickPlace.bind(this);
		this.showCourseDetail = this.showCourseDetail.bind(this);
		this.careerToggleTree = this.careerToggleTree.bind(this);
		this.classToggleTree = this.classToggleTree.bind(this);
		this.detailToggleTree = this.detailToggleTree.bind(this);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const careerID = this.props.match.params.career_id;

		// データ取得処理
		this.props.fetchCareerDetail(careerID, this.props.token);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		// データを破棄
		this.props.resetCareerDetail();
	}

	/**
	 * BASE64デコード
	 * @param base64 対象データ
	 */
	public getBlob(base64?: string) {
		if (base64 == null) {
			return null;
		}
		const contents = /data:([^;]*);/i.exec(base64);
		let contentType =
			contents != null && contents.length > 0 ? contents[1] : null;
		const b64Data = base64.substr(
			base64.indexOf('base64,') + 7,
			base64.length
		);
		let sliceSize = null;

		contentType = contentType || '';
		sliceSize = sliceSize || 512;

		const byteCharacters = atob(b64Data);
		const byteArrays = [];
		for (
			let offset = 0;
			offset < byteCharacters.length;
			offset += sliceSize
		) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);

			byteArrays.push(byteArray);
		}

		const blob = new Blob(byteArrays, { type: contentType });
		return blob;
	}
	/**
	 * 研修資料ダウンロード
	 */
	public downloadFile(event: React.MouseEvent<HTMLElement>) {
		const buttonId = event.currentTarget.id;
		// tslint:disable-next-line: radix
		const fileIndex = parseInt(buttonId.charAt(buttonId.length - 1));
		if (this.fileIndexInput != null) {
			let searchCondition = this.fileIndexInput.value;
			const dto = JSON.parse(searchCondition);
			dto.fileIndex = fileIndex;
			searchCondition = JSON.stringify(dto);
			this.fileIndexInput.value = searchCondition;
		}
		if (this.materialDownloadForm != null) {
			this.materialDownloadForm.submit();
		}
	}

	/**
	 * 実施場所情報取得
	 * @param item クラス情報
	 */
	public getClassRoomInfo(item: ICareerClass) {
		const { careerID, classID, classRoomNm } = item;
		const { classroom, placeUrl, placeFileName } = item;
		if (classID === 'CL000000') {
			// classroom = item.classroomDefault;
			// placeUrl = item.placeUrlDefault;
			// placeFileName = item.placeFileNameDefault;
			return '';
		}
		const classRoomValue =
			classroom && classroom !== '' ? classroom : classRoomNm;
		let classRoomElm;
		if (
			(!placeUrl || placeUrl === '') &&
			(!placeFileName || placeFileName === '')
		) {
			classRoomElm = classRoomValue;
		} else {
			classRoomElm = (
				<span
					className={this.props.classes.link}
					data-placeurl={placeUrl}
					data-placefilename={placeFileName}
					data-careerid={careerID}
					data-classid={classID}
					data-classroomnm={classRoomValue}
					onClick={this.onClickPlace}
				>
					{classRoomValue}
				</span>
			);
		}
		return classRoomElm;
	}

	/**
	 * 研修資料情報取得
	 * @param careerInfo 研修情報
	 */
	public getMaterialFiles(careerInfo: ICareerInfo) {
		const classes = this.props.classes;
		const rows: JSX.Element[] = [];
		if (
			careerInfo.materialFiles != null &&
			careerInfo.materialFiles.length > 0
		) {
			const materials = careerInfo.materialFiles;
			for (let i = 0; i < materials.length; i++) {
				const materialFileDTO = careerInfo.materialFiles[i];
				const fileName = materialFileDTO.fileName;
				const buttonId = 'buttonId' + i;
				const row = (
					<div key={'div' + i}>
						<span>{fileName}</span>
						<CloudDownloadIcon
							id={buttonId}
							// tslint:disable-next-line: jsx-no-bind
							onClick={this.downloadFile.bind(this)}
							className={classes.downloadButton}
						/>
					</div>
				);
				rows.push(row);
			}
		}
		return rows;
	}

	public render() {
		const { classes, careerInfo, careerClasses } = this.props;
		const {
			careerTypeID,
			contents,
			informationURL,
			textbook,
			reference,
			referenceURL,
			vendor,
			vendorURL,
			webAppFlg,
		} = careerInfo;
		const isSyuugouCareer: boolean = careerTypeID === 2 ? true : false;
		// 学習項目変換
		let contentsElm = '';
		if (contents) {
			const contentsList = contents.map((item: any) => item.contents);
			contentsElm = contentsList.join('<br/>');
		}
		// 期間
		let months = careerInfo.months;
		if (months && months !== '---') {
			months = months.substring(0, months.length - 2);
			months = i18n.t('CareerDetail_0040', {
				months,
			});
		}
		// 申込方法変換
		let howToApply = '';
		if (webAppFlg === '0') {
			howToApply = i18n.t('CareerDetail_0001');
		} else if (webAppFlg === '1') {
			howToApply = i18n.t('CareerDetail_0002');
		}

		// 資料
		let textbookElm;
		if (informationURL && informationURL !== '') {
			textbookElm = (
				<span
					className={classes.link}
					data-url={informationURL}
					onClick={this.onClickOpenTab}
				>
					{textbook}
				</span>
			);
		} else {
			textbookElm = textbook;
		}

		// ベンダ
		let verndorElm;
		if (vendorURL && vendorURL !== '') {
			verndorElm = (
				<span
					className={classes.link}
					data-url={vendorURL}
					onClick={this.onClickOpenTab}
				>
					{vendor}
				</span>
			);
		} else {
			verndorElm = vendor;
		}

		// 申込先
		let referenceElm;
		if (referenceURL && referenceURL !== '') {
			referenceElm = (
				<span
					className={classes.link}
					data-url={referenceURL}
					onClick={this.onClickOpenTab}
				>
					{reference}
				</span>
			);
		} else {
			referenceElm = reference;
		}
		const materialRows = this.getMaterialFiles(careerInfo);
		return (
			<div className={classes.root}>
				<div className={classes.wrapDiv}>
					{isMobile() && (
						<>
							<ListItem className={classes.listItem}>
								{this.state.careerInfoOpen ? (
									<ExpandMore />
								) : (
									<ChevronRight />
								)}
								<Typography
									variant="h6"
									color="inherit"
									className={classes.mobileFlex}
									onClick={this.careerToggleTree}
								>
									{i18n.t('CareerDetail_0003')}
								</Typography>
							</ListItem>
							<Paper className={classes.paper}>
								<div className={classes.mobileTable}>
									<div className={classes.mobileCellItemName}>
										{i18n.t('CareerDetail_0004')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{careerInfo.managementCode}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18n.t('CareerDetail_0005')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{careerInfo.careerTitle}
									</div>
									<Collapse
										in={this.state.careerInfoOpen}
										timeout="auto"
										unmountOnExit={true}
									>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0006')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{careerInfo.careerID}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0007')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{careerInfo.careerTypeName &&
												i18n.t(
													careerInfo.careerTypeName,
													{
														ns: 'force',
													}
												)}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0008')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{careerInfo.careerSubType}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0009')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{careerInfo.compulsoryID}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0010')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{careerInfo.target}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0011')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{careerInfo.organizer}
										</div>
									</Collapse>
								</div>
							</Paper>
						</>
					)}
					{!isMobile() && (
						<>
							<Typography
								variant="h6"
								color="inherit"
								className={classes.flex}
							>
								{i18n.t('CareerDetail_0003')}
							</Typography>
							<Paper className={classes.paper}>
								<Table className={classes.table}>
									<TableBody>
										<TableRow key={'managementCode'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0004')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.managementCode}
											</TableCell>
										</TableRow>
										<TableRow key={'careerTitle'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0005')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.careerTitle}
											</TableCell>
										</TableRow>
										<TableRow key={'careerID'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0006')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.careerID}
											</TableCell>
										</TableRow>
										<TableRow key={'careerTypeName'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0007')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.careerTypeName &&
													i18n.t(
														careerInfo.careerTypeName,
														{
															ns: 'force',
														}
													)}
											</TableCell>
										</TableRow>
										<TableRow key={'careerSubType'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0008')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.careerSubType}
											</TableCell>
										</TableRow>
										<TableRow key={'compulsoryID'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0009')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.compulsoryID}
											</TableCell>
										</TableRow>
										<TableRow key={'target'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0010')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.target}
											</TableCell>
										</TableRow>
										<TableRow key={'organizer'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0011')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.organizer}
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</Paper>
						</>
					)}
				</div>
				<div className={classes.wrapDiv}>
					{isMobile() && (
						<>
							<ListItem className={classes.listItem}>
								{this.state.classInfoOpen ? (
									<ExpandMore />
								) : (
									<ChevronRight />
								)}
								<Typography
									variant="h6"
									color="inherit"
									className={classes.mobileFlex}
									onClick={this.classToggleTree}
								>
									{i18n.t('CareerDetail_0012')}
								</Typography>
							</ListItem>
							<div className={classes.mobileTable}>
								{careerClasses.map(
									(item: ICareerClass, index: number) => {
										// 実施期間
										let startToEndDate =
											item.startToEndDate;
										if (
											startToEndDate &&
											startToEndDate.indexOf('～') !== -1
										) {
											startToEndDate = startToEndDate.replace(
												'～',
												i18n.t('～', {
													ns: 'force',
												})
											);
										}
										// 申込期間
										let application = item.application;
										if (
											application &&
											application.indexOf('～') !== -1
										) {
											application = application.replace(
												'～',
												i18n.t('～', {
													ns: 'force',
												})
											);
										}
										return (
											<>
												{index !== 0 && (
													<>
														<Collapse
															in={
																this.state
																	.classInfoOpen
															}
															timeout="auto"
															unmountOnExit={true}
														>
															<div
																style={{
																	maxHeight:
																		'5px',
																	minHeight:
																		'5px',
																}}
															/>
															<Paper
																className={
																	classes.paper
																}
															>
																<div
																	className={
																		classes.mobileCellItemName
																	}
																>
																	{i18n.t(
																		'CareerDetail_0013'
																	)}
																</div>
																<div
																	className={
																		classes.mobileCellItemValue
																	}
																>
																	{item.className &&
																	item.classID ===
																		'CL000000'
																		? i18n.t(
																				item.className,
																				{
																					ns:
																						'force',
																				}
																		  )
																		: item.className}
																</div>
																<div
																	className={
																		classes.mobileCellItemName
																	}
																>
																	{i18n.t(
																		'CareerDetail_0014'
																	)}
																</div>
																<div
																	className={
																		classes.mobileCellItemValue
																	}
																>
																	{
																		item.classID
																	}
																</div>
																<div
																	className={
																		classes.mobileCellItemName
																	}
																>
																	{i18n.t(
																		'CareerDetail_0015'
																	)}
																</div>
																<div
																	className={
																		classes.mobileCellItemValue
																	}
																>
																	{
																		startToEndDate
																	}
																</div>
																{isSyuugouCareer && (
																	<React.Fragment>
																		<div
																			className={
																				classes.mobileCellItemName
																			}
																		>
																			{i18n.t(
																				'CareerDetail_0016'
																			)}
																		</div>
																		<div
																			className={
																				classes.mobileCellItemValue
																			}
																		>
																			{this.getClassRoomInfo(
																				item
																			)}
																		</div>
																	</React.Fragment>
																)}
																<div
																	className={
																		classes.mobileCellItemName
																	}
																>
																	{i18n.t(
																		'CareerDetail_0017'
																	)}
																</div>
																<div
																	className={
																		classes.mobileCellItemValue
																	}
																>
																	{
																		item.capacity
																	}
																</div>
																<div
																	className={
																		classes.mobileCellItemName
																	}
																>
																	{i18n.t(
																		'CareerDetail_0018'
																	)}
																</div>
																<div
																	className={
																		classes.mobileCellItemValue
																	}
																>
																	{item.cost}
																</div>
																<div
																	className={
																		classes.mobileCellItemName
																	}
																>
																	{i18n.t(
																		'CareerDetail_0019'
																	)}
																</div>
																<div
																	className={
																		classes.mobileCellItemValue
																	}
																>
																	{item.cost1}
																</div>
																<div
																	className={
																		classes.mobileCellItemName
																	}
																>
																	{i18n.t(
																		'CareerDetail_0020'
																	)}
																</div>
																<div
																	className={
																		classes.mobileCellItemValue
																	}
																>
																	{
																		application
																	}
																</div>
															</Paper>
														</Collapse>
													</>
												)}
												{index === 0 && (
													<Paper
														className={
															classes.paper
														}
													>
														<div
															className={
																classes.mobileCellItemName
															}
														>
															{i18n.t(
																'CareerDetail_0013'
															)}
														</div>
														<div
															className={
																classes.mobileCellItemValue
															}
														>
															{item.className &&
															item.classID ===
																'CL000000'
																? i18n.t(
																		item.className,
																		{
																			ns:
																				'force',
																		}
																  )
																: item.className}
														</div>
														<Collapse
															in={
																this.state
																	.classInfoOpen
															}
															timeout="auto"
															unmountOnExit={true}
														>
															<div
																className={
																	classes.mobileCellItemName
																}
															>
																{i18n.t(
																	'CareerDetail_0014'
																)}
															</div>
															<div
																className={
																	classes.mobileCellItemValue
																}
															>
																{item.classID}
															</div>
														</Collapse>
														<div
															className={
																classes.mobileCellItemName
															}
														>
															{i18n.t(
																'CareerDetail_0015'
															)}
														</div>
														<div
															className={
																classes.mobileCellItemValue
															}
														>
															{startToEndDate}
														</div>
														{isSyuugouCareer && (
															<React.Fragment>
																<div
																	className={
																		classes.mobileCellItemName
																	}
																>
																	{i18n.t(
																		'CareerDetail_0016'
																	)}
																</div>
																<div
																	className={
																		classes.mobileCellItemValue
																	}
																>
																	{this.getClassRoomInfo(
																		item
																	)}
																</div>
															</React.Fragment>
														)}
														<Collapse
															in={
																this.state
																	.classInfoOpen
															}
															timeout="auto"
															unmountOnExit={true}
														>
															<div
																className={
																	classes.mobileCellItemName
																}
															>
																{i18n.t(
																	'CareerDetail_0017'
																)}
															</div>
															<div
																className={
																	classes.mobileCellItemValue
																}
															>
																{item.capacity}
															</div>
															<div
																className={
																	classes.mobileCellItemName
																}
															>
																{i18n.t(
																	'CareerDetail_0018'
																)}
															</div>
															<div
																className={
																	classes.mobileCellItemValue
																}
															>
																{item.cost}
															</div>
															<div
																className={
																	classes.mobileCellItemName
																}
															>
																{i18n.t(
																	'CareerDetail_0019'
																)}
															</div>
															<div
																className={
																	classes.mobileCellItemValue
																}
															>
																{item.cost1}
															</div>
															<div
																className={
																	classes.mobileCellItemName
																}
															>
																{i18n.t(
																	'CareerDetail_0020'
																)}
															</div>
															<div
																className={
																	classes.mobileCellItemValue
																}
															>
																{application}
															</div>
														</Collapse>
													</Paper>
												)}
											</>
										);
									},
									this
								)}
							</div>
						</>
					)}
					{!isMobile() && (
						<>
							<Typography
								variant="h6"
								color="inherit"
								className={classes.flex}
							>
								{i18n.t('CareerDetail_0012')}
							</Typography>
							<Paper className={classes.paper}>
								<Table className={classes.tableClass}>
									{isSyuugouCareer && (
										<colgroup>
											<col width={'15%'} />
											<col width={'10%'} />
											<col width={'13%'} />
											<col width={'14%'} />
											<col width={'8%'} />
											<col width={'10%'} />
											<col width={'12%'} />
											<col width={'18%'} />
										</colgroup>
									)}

									{!isSyuugouCareer && (
										<colgroup>
											<col width={'17%'} />
											<col width={'12%'} />
											<col width={'15%'} />
											<col width={'10%'} />
											<col width={'12%'} />
											<col width={'14%'} />
											<col width={'20%'} />
										</colgroup>
									)}

									<TableHead>
										<TableRow
											id={i18n.t('CareerDetail_0012')}
										>
											<TableCell
												className={classes.headerName}
												size="small"
											>
												{i18n.t('CareerDetail_0013')}
											</TableCell>
											<TableCell
												className={classes.headerName}
												size="small"
											>
												{i18n.t('CareerDetail_0014')}
											</TableCell>
											<TableCell
												className={classes.headerName}
												size="small"
											>
												{i18n.t('CareerDetail_0015')}
											</TableCell>
											{isSyuugouCareer && (
												<TableCell
													className={
														classes.headerName
													}
													size="small"
												>
													{i18n.t(
														'CareerDetail_0016'
													)}
												</TableCell>
											)}
											<TableCell
												className={classes.headerName}
												size="small"
											>
												{i18n.t('CareerDetail_0017')}
											</TableCell>
											<TableCell
												className={classes.headerName}
												size="small"
											>
												{i18n.t('CareerDetail_0018')}
											</TableCell>
											<TableCell
												className={classes.headerName}
												size="small"
											>
												{i18n.t('CareerDetail_0019')}
											</TableCell>
											<TableCell
												className={classes.headerName}
												size="small"
											>
												{i18n.t('CareerDetail_0020')}
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{careerClasses.map(
											(
												item: ICareerClass,
												index: number
											) => {
												// 実施期間
												let startToEndDate =
													item.startToEndDate;
												if (
													startToEndDate &&
													startToEndDate.indexOf(
														'～'
													) !== -1
												) {
													startToEndDate = startToEndDate.replace(
														'～',
														i18n.t('～', {
															ns: 'force',
														})
													);
												}
												// 申込期間
												let application =
													item.application;
												if (
													application &&
													application.indexOf(
														'～'
													) !== -1
												) {
													application = application.replace(
														'～',
														i18n.t('～', {
															ns: 'force',
														})
													);
												}
												return (
													<TableRow
														key={item.classID}
													>
														<TableCell size="small">
															{item.className &&
															item.classID ===
																'CL000000'
																? i18n.t(
																		item.className,
																		{
																			ns:
																				'force',
																		}
																  )
																: item.className}
														</TableCell>
														<TableCell size="small">
															{item.classID}
														</TableCell>
														<TableCell size="small">
															{startToEndDate}
														</TableCell>
														{isSyuugouCareer && (
															<TableCell size="small">
																{this.getClassRoomInfo(
																	item
																)}
															</TableCell>
														)}
														<TableCell size="small">
															{item.capacity}
														</TableCell>
														<TableCell size="small">
															{item.cost}
														</TableCell>
														<TableCell size="small">
															{item.cost1}
														</TableCell>
														<TableCell size="small">
															{application}
														</TableCell>
													</TableRow>
												);
											},
											this
										)}
									</TableBody>
								</Table>
							</Paper>
						</>
					)}
				</div>
				<div className={classes.wrapDiv}>
					{isMobile() && (
						<>
							<ListItem className={classes.listItem}>
								{this.state.detailInfoOpen ? (
									<ExpandMore />
								) : (
									<ChevronRight />
								)}
								<Typography
									variant="h6"
									color="inherit"
									className={classes.mobileFlex}
									onClick={this.detailToggleTree}
								>
									{i18n.t('CareerDetail_0021')}
								</Typography>
							</ListItem>
							{careerInfo.careerTypeID &&
								careerInfo.careerTypeID === 1 &&
								careerInfo.haveContents === 1 && (
									<Button
										className={classes.button}
										variant="contained"
										color="default"
										onClick={this.showCourseDetail}
									>
										{i18n.t('CareerDetail_0022')}
									</Button>
								)}
							<Paper className={classes.paper}>
								<div className={classes.mobileTable}>
									<div className={classes.mobileCellItemName}>
										{i18n.t('CareerDetail_0023')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{careerInfo.purpose}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18n.t('CareerDetail_0024')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{careerInfo.outline}
									</div>
									<Collapse
										in={this.state.detailInfoOpen}
										timeout="auto"
										unmountOnExit={true}
									>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0025')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
											dangerouslySetInnerHTML={{
												__html: contentsElm,
											}}
										/>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0026')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{months}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0027')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{careerInfo.credit}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0028')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{careerInfo.studyTime}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0029')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{careerInfo.author}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0030')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{careerInfo.version}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0031')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{textbookElm}
										</div>
										{isSyuugouCareer && (
											<>
												<div
													className={
														classes.mobileCellItemName
													}
												>
													{i18n.t(
														'CareerDetail_0032'
													)}
												</div>
												<div
													className={
														classes.mobileCellItemValue
													}
												>
													{materialRows &&
														materialRows.length >
															0 &&
														materialRows}
												</div>
											</>
										)}
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0033')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{verndorElm}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0034')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{careerInfo.inquiry}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0035')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{howToApply}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0036')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{referenceElm}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0037')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{careerInfo.enquete &&
												i18n.t(careerInfo.enquete, {
													ns: 'force',
												})}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0038')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{careerInfo.careerReport &&
												i18n.t(
													careerInfo.careerReport,
													{
														ns: 'force',
													}
												)}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CareerDetail_0039')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{careerInfo.comment}
										</div>
									</Collapse>
								</div>
							</Paper>
						</>
					)}
					{!isMobile() && (
						<>
							<Typography
								variant="h6"
								color="inherit"
								className={classes.flex}
							>
								{i18n.t('CareerDetail_0021')}
								{careerInfo.careerTypeID &&
									careerInfo.careerTypeID === 1 &&
									careerInfo.haveContents === 1 && (
										<Button
											className={classes.button}
											variant="contained"
											color="default"
											onClick={this.showCourseDetail}
										>
											{i18n.t('CareerDetail_0022')}
										</Button>
									)}
							</Typography>
							<Paper className={classes.paper}>
								<Table className={classes.table}>
									<TableBody>
										<TableRow key={'purpose'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0023')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.purpose}
											</TableCell>
										</TableRow>
										<TableRow key={'outline'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0024')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.outline}
											</TableCell>
										</TableRow>
										<TableRow key={'contentsElm'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0025')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
												dangerouslySetInnerHTML={{
													__html: contentsElm,
												}}
											/>
										</TableRow>
										<TableRow key={'months'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0026')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{months}
											</TableCell>
										</TableRow>
										<TableRow key={'credit'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0027')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.credit}
											</TableCell>
										</TableRow>
										<TableRow key={'studyTime'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0028')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.studyTime}
											</TableCell>
										</TableRow>
										<TableRow key={'author'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0029')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.author}
											</TableCell>
										</TableRow>
										<TableRow key={'version'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0030')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.version}
											</TableCell>
										</TableRow>
										<TableRow key={'textbookElm'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0031')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{textbookElm}
											</TableCell>
										</TableRow>
										{isSyuugouCareer && (
											<TableRow key={'materials'}>
												<TableCell
													className={
														classes.cellItemName
													}
												>
													{i18n.t(
														'CareerDetail_0032'
													)}
												</TableCell>
												<TableCell
													className={
														classes.cellItemValue
													}
												>
													{materialRows &&
														materialRows.length >
															0 &&
														materialRows}
												</TableCell>
											</TableRow>
										)}
										<TableRow key={'verndorElm'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0033')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{verndorElm}
											</TableCell>
										</TableRow>
										<TableRow key={'inquiry'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0034')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.inquiry}
											</TableCell>
										</TableRow>
										<TableRow key={'howToApply'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0035')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{howToApply}
											</TableCell>
										</TableRow>
										<TableRow key={'referenceElm'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0036')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{referenceElm}
											</TableCell>
										</TableRow>
										<TableRow key={'enquete'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0037')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.enquete &&
													i18n.t(careerInfo.enquete, {
														ns: 'force',
													})}
											</TableCell>
										</TableRow>
										<TableRow key={'careerReport'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0038')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.careerReport &&
													i18n.t(
														careerInfo.careerReport,
														{
															ns: 'force',
														}
													)}
											</TableCell>
										</TableRow>
										<TableRow key={'comment'}>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('CareerDetail_0039')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{careerInfo.comment}
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</Paper>
						</>
					)}
				</div>
				<form
					method="POST"
					action={
						Config.tsqPath +
						'/tsq/pkg/action/downloadImageFile.action'
					}
					target="_blank"
					ref={form => (this.elmForm = form)}
				>
					<input
						type="hidden"
						name="downloadActionName"
						value={
							Config.tsqPath +
							'/tsq/pkg/action/downloadPlaceFile.action'
						}
					/>
					<input type="hidden" name="accessType" value="10" />
					<input
						type="hidden"
						name="downloadWindowTitle"
						value=""
						ref={downloadWindowTitle =>
							(this.elmDownloadWindowTitle = downloadWindowTitle)
						}
					/>
					<input
						type="hidden"
						name="downloadFileType"
						value=""
						ref={downloadFileType =>
							(this.elmDownloadFileType = downloadFileType)
						}
					/>
					<input
						type="hidden"
						name="parameters"
						value=""
						ref={parameters => (this.elmParameters = parameters)}
					/>
				</form>
				<form
					method="POST"
					action={
						Config.tsqPath +
						'/tsq/pkg/action/el/materialFileDownload.action'
					}
					ref={form => (this.materialDownloadForm = form)}
					target="_blank"
				>
					<input
						type="hidden"
						name="searchCondition"
						value={`{"careerID":"${
							careerInfo.careerID
						}","fileIndex":"0"}`}
						ref={fileIndexInput =>
							(this.fileIndexInput = fileIndexInput)
						}
					/>
					<input
						type="hidden"
						name="__tsqCookieName"
						value="TSQ_FD_0"
					/>
					<input type="hidden" name="__tsqFileType" value="csv" />
				</form>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.props.openCourseDialog}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
						scrollPaper: this.props.classes.scrollPaper,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('CareerDetail_0022')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CourseDetail careerID={this.props.careerID} />
				</Dialog>
			</div>
		);
	}

	/**
	 * 実施場所選択ハンドラ
	 * @param e
	 */
	protected onClickPlace(e: React.MouseEvent<HTMLElement>) {
		const placeUrl = e.currentTarget.getAttribute('data-placeurl');
		const placeFileName = e.currentTarget.getAttribute(
			'data-placefilename'
		);
		const careerId = e.currentTarget.getAttribute('data-careerid');
		const classId = e.currentTarget.getAttribute('data-classid');
		const classRoomNm =
			e.currentTarget.getAttribute('data-classroomnm') || '';
		if (placeUrl && placeUrl !== '') {
			window.open(placeUrl, '_blank');
		} else if (placeFileName && placeFileName !== '') {
			let fileType = placeFileName.split('.').pop();
			if (!fileType) {
				return;
			}
			fileType = fileType.toLocaleLowerCase();
			if (fileType === 'png') {
				fileType = 'PNG';
			} else if (fileType === 'gif') {
				fileType = 'GIF';
			} else {
				fileType = 'JPEG';
			}
			const paramData =
				'{"careerId" : "' +
				careerId +
				'", "classId" : "' +
				classId +
				'"}';
			if (
				this.elmDownloadWindowTitle &&
				this.elmDownloadFileType &&
				this.elmParameters &&
				this.elmForm
			) {
				this.elmDownloadWindowTitle.value = classRoomNm;
				this.elmDownloadFileType.value = fileType;
				this.elmParameters.value = paramData;
				this.elmForm.submit();
			}
		}
	}

	/**
	 * リンク先クリックハンドラ
	 * @param e
	 */
	protected onClickOpenTab(e: React.MouseEvent<HTMLElement>) {
		const url = e.currentTarget.getAttribute('data-url');
		if (url && url !== '') {
			window.open(url, '_blank');
		}
	}

	protected careerToggleTree(e: React.MouseEvent<HTMLElement>) {
		this.setState({ careerInfoOpen: !this.state.careerInfoOpen });
	}

	protected classToggleTree(e: React.MouseEvent<HTMLElement>) {
		this.setState({ classInfoOpen: !this.state.classInfoOpen });
	}

	protected detailToggleTree(e: React.MouseEvent<HTMLElement>) {
		this.setState({ detailInfoOpen: !this.state.detailInfoOpen });
	}

	/**
	 * 章立て情報クリックハンドラ
	 * @param e
	 */
	protected showCourseDetail(e: React.MouseEvent<HTMLElement>) {
		const { careerInfo, careerID } = this.props;
		if (careerID) {
			this.props.setCourseDetailDialog(true);
		} else {
			if (careerInfo.careerID) {
				let to = Routes.getPath(Screens.PERSONAL_COURSE_DETAIL);
				to = to.replace(/\/:career_id/, `/${careerInfo.careerID}`);
				this.props.pushHistory(to);
			}
		}
	}

	protected handlecloseDetailDialog = () => {
		this.props.setCourseDetailDialog(false);
	};
}

const mapStateToProps = (state: IRootState) => ({
	careerClasses: state.search.career.careerClasses,
	careerInfo: state.search.career.careerInfo,
	openCourseDialog: state.search.OpenCourseDetailDialog,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchCareerDetail: (careerId: string, token: string) => {
		const s = ScenarioFactory.createFetchCareerDetail(dispatch, token);
		s.run(careerId);
	},
	pushHistory: (path: string) => dispatch(push(path)),
	resetCareerDetail: () =>
		dispatch(
			setCareerDetail({ careerInfo: { contents: [] }, careerClasses: [] })
		),
	setCourseDetailDialog: (OpenCourseDetailDialog: boolean) =>
		dispatch(setCourseDetailDialog({ OpenCourseDetailDialog })),
});

export interface ICareerDetailProps {
	careerID: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	ICareerDetailProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(CareerDetail);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<ICareerDetailProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/CareerDetail.tsx